import { toast } from "react-toastify";

export const useToast = () => {
  const success = (message) => {
    toast.success(message, {
      position: toast.POSITION.BOTTOM_CENTER,
      autoClose: 10000,
      closeOnClick: true,
    });
  };

  const error = (message) => {
    toast.error(message, {
      position: toast.POSITION.BOTTOM_CENTER,
      autoClose: 10000,
      closeOnClick: true,
    });
  };

  const info = (message) => {
    toast.info(message, {
      position: toast.POSITION.BOTTOM_CENTER,
      autoClose: 10000,
      closeOnClick: true,
    });
  };

  return {
    success: (message) => success(message),
    error: (message) => error(message),
    info: (message) => info(message),
  };
};
